var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluatedSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.772 14H20.772C20.2415 14 19.7328 14.2107 19.3578 14.5858C18.9827 14.9609 18.772 15.4696 18.772 16V28C18.772 28.5304 18.9827 29.0391 19.3578 29.4142C19.7328 29.7893 20.2415 30 20.772 30H32.772C33.3024 30 33.8111 29.7893 34.1862 29.4142C34.5613 29.0391 34.772 28.5304 34.772 28V16C34.772 15.4696 34.5613 14.9609 34.1862 14.5858C33.8111 14.2107 33.3024 14 32.772 14ZM32.772 28H20.772V16H32.772V28ZM28.772 32V34H16.772C16.2415 34 15.7328 33.7893 15.3578 33.4142C14.9827 33.0391 14.772 32.5304 14.772 32V19H16.772V32H28.772ZM31.302 20.06L30.242 19L25.362 23.88L23.242 21.76L22.182 22.82L25.362 26L31.302 20.06Z",
    fill: "#4DA721"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluatedSupplyReqIcon);
export default __webpack_public_path__ + "static/media/evaluated-supply-req-icon.e9f8426250f65ad935e4101a204d7dc9.svg";
export { ForwardRef as ReactComponent };